import styled from "styled-components";

export const PageContainer = styled.div`
  width: 100%;
  min-height: 454px;
  position: relative;
`;

export const VacationPeriodInfoContainer = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: ${({ theme }) => theme.colors.white};
  box-shadow: 0px 0px 32px 0px #00000029;
  padding: 32px;
  border-radius: 16px;
  min-width: 496px;
  min-height: 168px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-items: center;
  gap: 24px;
`;

export const NewSemesterTitle = styled.p`
  font-family: ${({ theme }) => theme.fonts.primary};
  font-size: ${({ theme }) => theme.fontSizes["3xl"]};
  font-weight: 700;
  text-align: center;
  line-height: 42px;
  margin: 0;
`;

export const NewSemesterDescription = styled.p`
  margin: 0;
  text-align: center;
  width: 285px;
  padding: 8px 16px;
  background-color: ${({ theme }) => theme.colors.yellow["100"]};
  border-radius: 6px;
  line-height: 22px;
`;
